import React, { useState } from 'react';

const ReflexTester = ({ onClose }) => {
  const [testing, setTesting] = useState(false);
  const [completedTest, setCompletedTest] = useState(false);
  const [reflexTime, setReflexTime] = useState(null);
  const [reflexBtnText, setReflexBtnText] = useState('Begin');
  const [timer, setTimer] = useState(null);

  const pretestBackgroundColor = '#ffe119';
  const postestBackgroundColor = '#3cb44b';

  const beginTest = () => {
    setTesting(true);
    setCompletedTest(false);
    setReflexBtnText('Get Ready...');

    const randomTime = Math.floor(Math.random() * (4001)) + 1000;

    setTimeout(() => {
      setReflexBtnText('CLICK NOW!');
      setTimer(Date.now());
    }, randomTime);
  };

  const finishTest = () => {
    if (!testing) {
      return;
    }

    setTesting(false);
    setCompletedTest(true);

    const finishTime = Date.now();
    const timeDiff = finishTime - timer;
    setReflexTime(timeDiff);
    setTimer(null);
    setReflexBtnText('Try Again?');
  };

  const resetTest = () => {
    setTesting(false);
    setCompletedTest(false);
    setReflexTime(null);
    setReflexBtnText('Begin');
    setTimer(null);
  };

  const handleButtonClick = () => {
    if (!testing && !completedTest) {
      beginTest();
    } else if (testing) {
      finishTest();
    } else if (completedTest) {
      resetTest();
    }
  };

  return (
    <div>
      <div 
        className="text-center p-5 mb-4"
        style={{
          backgroundColor: testing && reflexBtnText === 'CLICK NOW!' ? postestBackgroundColor : pretestBackgroundColor,
          borderRadius: '10px',
          transition: 'background-color 0.3s ease'
        }}
      >
        <h3 className="mb-4">Reflex Tester</h3>
        <p className="mb-4">
          {testing && reflexBtnText === 'Get Ready...' && 'Wait for the color to change...'}
          {testing && reflexBtnText === 'CLICK NOW!' && 'Click the button as fast as you can!'}
          {!testing && !completedTest && 'Click "Begin" to start the test'}
          {completedTest && `Your reflex time: ${reflexTime}ms`}
        </p>
        <button
          className={`btn btn-lg ${testing && reflexBtnText === 'CLICK NOW!' ? 'btn-success' : 'btn-primary'}`}
          onClick={handleButtonClick}
          disabled={testing && reflexBtnText === 'Get Ready...'}
        >
          {reflexBtnText}
        </button>
      </div>

      {completedTest && (
        <div className="alert alert-success">
          <h5>Test Results:</h5>
          <p><strong>Your reflex time:</strong> {reflexTime}ms</p>
          <p>
            {reflexTime < 200 && 'Excellent reflexes!'}
            {reflexTime >= 200 && reflexTime < 300 && 'Good reflexes!'}
            {reflexTime >= 300 && reflexTime < 400 && 'Average reflexes.'}
            {reflexTime >= 400 && 'Try to improve your reaction time.'}
          </p>
        </div>
      )}

      <div className="mt-4">
        <h6>Instructions:</h6>
        <ol>
          <li>Click "Begin" to start the test</li>
          <li>Wait for the background to change color</li>
          <li>Click the button as quickly as possible when it turns green</li>
          <li>Your reflex time will be displayed</li>
        </ol>
      </div>
    </div>
  );
};

export default ReflexTester;
